import React, { Component } from 'react'
import { connect } from 'react-redux'
import cn from 'classnames'
import { injectIntl } from 'react-intl'
import {
  FormControl,
  Input,
  InputLabel,
  Icon,
  FormControlLabel,
} from '@material-ui/core'
import messages from 'routes/App/Apps/LogbookForm/translate'
import { showNotice } from 'reducers/notice'
import NoticeHelper from 'helpers/notice'
import { uploadFiles, removeFiles } from 'reducers/common/files/reducer'
import withPromise from 'helpers/withPromise'

class EventResultFileInput extends Component {
  constructor(props) {
    super(props)
    const {
      eventInfo: { evt_logbook_id, previous_value, value },
    } = props
    this.state = {
      evt_logbook_id,
      previousValue: previous_value,
      value,
    }
  }

  shouldComponentUpdate(nextProps) {
    const { eventInfo } = nextProps

    if (this.props.eventInfo !== eventInfo) {
      const { evt_logbook_id, previous_value, value } = eventInfo
      this.setState({
        evt_logbook_id,
        previousValue: previous_value,
        value,
      })

      return false
    }

    return true
  }

  setResultId = ({ id }) => {
    this.setState({
      evt_logbook_id: id,
    })
  }

  onAutoSaveValue = () => {
    const { value, evt_logbook_id } = this.state
    const { onValueChange, eventInfo } = this.props

    onValueChange({
      ...eventInfo,
      value: value.id,
      evt_logbook_id,
      setResultId: this.setResultId,
    })
  }

  onChangeFile = e => {
    const {
      showNotice,
      uploadFiles,
      intl: { formatMessage },
    } = this.props
    const [file] = e.currentTarget.files

    if (!file) {
      return false
    }

    const fileForm = new FormData()
    fileForm.append('file', file)

    withPromise(uploadFiles, {
      file: fileForm,
      formatMessage,
    }).then(response => {
      if (response.error) {
        showNotice({
          notice: NoticeHelper.createErrorObj(
            formatMessage(messages.fileNotUploadMessage),
          ),
        })
      } else {
        // TODO: как то доделать удаление старого файла после сохранения
        this.setState(
          {
            value: response,
          },
          () => {
            this.onAutoSaveValue()
          },
        )
      }
    })
  }

  render() {
    const {
      tabIndex,
      dataIndex,
      disabled,
      intl: { formatMessage },
      eventInfo: {
        parameters: { file_title },
      },
    } = this.props
    const inputId = `eventFile${dataIndex}`
    const { value } = this.state
    const uploadedFile = Boolean(value)

    return (
      <FormControl fullWidth className="form-group">
        <FormControlLabel
          className="lbf-control-label"
          labelPlacement="top"
          label={file_title && formatMessage({ id: file_title })}
          control={
            <>
              <InputLabel
                htmlFor={inputId}
                className={cn('event-result-file-input-label', {
                  'file-title': Boolean(uploadedFile),
                })}>
                {!uploadedFile && (
                  <>
                    <Icon>attach_file</Icon>
                    {formatMessage(messages.uploadPdfPngJpg)}
                  </>
                )}
                {Boolean(uploadedFile) && (
                  <div className="event-file-uploaded">
                    <Icon>insert_drive_file</Icon>
                    <a
                      href={value.uri}
                      title={value.originalName}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="file-link">
                      {value.originalName}
                    </a>
                    <Icon>publish</Icon>
                  </div>
                )}
              </InputLabel>
              <Input
                id={inputId}
                type="file"
                onChange={this.onChangeFile}
                className="event-result-file-input"
                inputProps={{
                  fullWidth: true,
                  'data-index': dataIndex,
                  tabIndex,
                  accept:
                    'image/jpeg,image/png,image/tiff,.tif,.tiff,application/pdf,application/x-pdf',
                }}
                disabled={disabled}
              />
            </>
          }
        />
      </FormControl>
    )
  }
}

export default connect(null, {
  showNotice,
  uploadFiles,
  removeFiles,
})(injectIntl(EventResultFileInput))
